import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "notice-mask"
}
const _hoisted_2 = { class: "notice-container" }
const _hoisted_3 = { class: "notice-contnet" }
const _hoisted_4 = { class: "version-info" }
const _hoisted_5 = { class: "ml50" }
const _hoisted_6 = { class: "update-info" }
const _hoisted_7 = { class: "update-content" }

import { useUserStore } from "@/store";
import { onMounted, ref, watch } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'NoticeDialog',
  props: {
  noticeInfos: {
    type: Array,
    defulat: [],
  },
},
  setup(__props) {

const props = __props;
const userStore = useUserStore();
const showNotice = ref(false);
watch(
  () => userStore.userInfo.isNewVersion,
  (newValue) => {
    showNotice.value = newValue === false;
  }
);
const onClose = () => {
  userStore.userInfo.isNewVersion = true;
};
onMounted(()=>{
  showNotice.value = userStore.userInfo.isNewVersion === false;
  console.log(props.noticeInfos,'props.noticeInfos')
})

return (_ctx: any,_cache: any) => {
  return (showNotice.value && props.noticeInfos?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "notice-close",
            onClick: onClose
          }, "x"),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, "更新版本：" + _toDisplayString(props.noticeInfos[0]), 1),
              _createElementVNode("span", _hoisted_5, "更新时间：" + _toDisplayString(props.noticeInfos[1]), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "update-title" }, "更新内容", -1)),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.noticeInfos.slice(2, props.noticeInfos.length), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mb5",
                    key: index
                  }, _toDisplayString(index + 1) + "、" + _toDisplayString(item), 1))
                }), 128))
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})